import { set_alt, set_control, set_gui, set_shift } from './keypress';
import app from './application-container';
import { unsuppress_undo_tracking_if_ready } from './utility';
import { hide_all_modals } from './state';

/** display a modal
 *
 * - `modal_name` — the modal to show
 */
export function show_modal(modal_name: keyof typeof app.state.modal,
    preserve_keypress_states = false,
) {
    if (!preserve_keypress_states) {
        set_shift(false);
        set_gui(false);
        set_alt(false);
        set_control(false);
    }
    app.state.modal[modal_name] = true;
}

/** Check whether a modal is currently open
 *
 * - `modal_name` — the modal to enquire about
 */
export function modal_is_open(modal_name: keyof typeof app.state.modal) {
    return app.state.modal[modal_name];
}


/** hide a modal, or hide all modals
 *
 * - `modal_name` — the modal to hide. Null to hide all modals
 * - `preserve_keypress_states` — don't modify keypress states
 */
export function hide_modal(
    modal_name: keyof typeof app.state.modal | null = null,
    preserve_keypress_states = false,
) {
    if (modal_name && modal_is_open(modal_name))
        unsuppress_undo_tracking_if_ready(false);
    if (modal_name)
        app.state.modal[modal_name] = false;
    else
        hide_all_modals();
    if (!preserve_keypress_states) {
        set_shift(false);
        set_gui(false);
        set_alt(false);
        set_control(false);
    }
}
